class LocalStorageService {
  restore(key, defaultObj = {}) {
    const v = localStorage.getItem(key)
    let obj = defaultObj
    if (v) {
      const pv = JSON.parse(v)
      if (pv) {
        obj = pv
      }
    }
    return obj
  }
  save(key, obj) {
    localStorage.setItem(key, JSON.stringify(obj))
  }
  remove(key) {
    localStorage.removeItem(key)
  }
  set(key, str) {
    localStorage.setItem(key, str)
  }
  get(key) {
    return localStorage.getItem(key)
  }

  setNumber(key, num) {
    this.set(key, num)
  }
  getNumber(key) {
    const num = Number(this.get(key))
    return num ? num : 0
  }

  setBoolean(key, b) {
    this.set(key, String(b))
  }
  getBoolean(key, iv) {
    const v = this.get(key)
    if (v) {
      return v == 'true'
    }
    return iv
  }
}

const localStorageService = new LocalStorageService()
export default localStorageService
